export const ZINDEX = {
  BASE: 0,
  CONTENT: 300,
  HEADER: 1200,
  POPUP_WINDOW: 1300,
  ERROR_MESSAGE: 1600,
  ERROR_SCREEN: 2000,
  OVERLAY: 2000,
};
